import {get, post} from './api';

const getProjectInfo = get('project/info');
const getRecommendedProjects = get('project/recommended');
const getMyProjects = get('project/mine');
const deleteProject = post('project/delete');
// 移除分享作品
const deleteShareProject = post('project/stop-share')

export {
    getProjectInfo,
    getRecommendedProjects,
    getMyProjects,
    deleteProject,
    deleteShareProject,
};
